import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';
import { CONTACT } from '@common/constants';

import { Plumbing } from '@modules/services/plumbing/Plumbing';

const TITLE = 'Trusted Plumbing Service in London | Qeeper';
const DESC = `Need a plumbing service that flushes out your problems? Our team will have your drains unblocked and clean in no time. Call ${CONTACT.PHONE}`;

const URL = 'https://www.qeeper.co.uk/services/plumbing';

const SEO_KEYWORDS =
  'plumbing service, london plumbing, pipe fitters near me, professional plumber, book plumber online';
const PlumbingPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <Plumbing />
    </>
  );
};

export default PlumbingPage;
